import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import NasnimanyCiarovyKod from "../../common/SnimanieCiarovehoKodu/NasnimanyCiarovyKod";
import CheckBalikFromCiarovyKod from "../../common/SnimanieCiarovehoKodu/CheckBalikFromCiarovyKod";
import { Zvuky } from "../../common/Zvuky";
import { MessageTypeEnum, CiarovyKodAllowedHandleKeys, ButtonGroupEnum, ButtonMessageEnum } from "../../../enums";
import confirmService from "../../common/confirmService";
import KeyboardEventHandler from "react-keyboard-event-handler";
import { prijemBalikaController } from "../../../controllers/prijembalika.controller";
import { Localization } from "../../common/Localization";
import LoadingPanel from "../../common/LoadingPanel";
import { dateConvert } from "../../common/Helpers";

class PotvrditPrijemDodavkyDialogContent extends Component {
    state = { loading: true, items: [] };

    componentDidMount() {
        this.refreshGrid();
    }

    CheckNewBalik = async response => {
        if (response.isError) {
            Zvuky.playChyba();
            await confirmService.show({
                type: MessageTypeEnum.EXCLAMATION,
                message: response.errorMessage
            });
            return;
        }
        this.potvrditPrijem(response.zadanyKod);
    };

    refreshGrid = async () => {
        this.setState({ loading: true });
        prijemBalikaController.potvrdPrijemDodavkyAktualizovatZoznam().then(async response => {
            if (response.isError) {
                await confirmService.show({
                    type: MessageTypeEnum.CRITICAL,
                    message: response.errorMessage,
                    logMessage: true
                });
                this.props.toggleDialog();
            }
            let data = JSON.parse(JSON.stringify(response), dateConvert);
            this.setState({
                loading: false,
                items: data.zoznamDodavok
            });
        });
    };

    async potvrditPrijem(ciarovyKod, potvrdeno = false) {
        var response = await prijemBalikaController.potvrdPrijemDodavkyNaskenovanimBalika(ciarovyKod, potvrdeno);
        if (response.isError || response.isQuestion || response.isInformative) {
            const confirmResult = await confirmService.show({
                type: response.isError ? MessageTypeEnum.EXCLAMATION : MessageTypeEnum.INFORMATIVE,
                message: response.errorMessage,
                buttons: response.isQuestion ? ButtonGroupEnum.YES_NO : null,
                logMessage: true
            });

            if (response.isQuestion && confirmResult == ButtonMessageEnum.YES) {
                await this.potvrditPrijem(ciarovyKod, true);
                this.refreshGrid();
                this.props.reloadNahlasNenahlasDodavkyGrid();
                this.props.reloadSpravyGrid();
                return;
            }

            if (response.isInformative) {
                this.setState({ items: response.zoznamDodavok });
            }
        }
    }

    handleKeyEvent(key, e) {
        this.setState({
            keyboardEvent: e
        });
        e.preventDefault();
        return false;
    }

    renderGrid() {
        var items = this.state.items;
        var localizationService = provideLocalizationService(this);

        return (
            <Grid
                data={items}
                total={items ? items.length : 0}
                pageSize={items ? items.length : 0}
                pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}>
                <GridColumn field="datum" title={localizationService.toLanguageString("PotvrdeniePrijmuD.Expedováno", "Expedováno")} />
                <GridColumn field="nazov" title={localizationService.toLanguageString("PotvrdeniePrijmuD.Odosielatel", "Odosielatel")} />
                <GridColumn field="cisloDodavky" title={localizationService.toLanguageString("PotvrdeniePrijmuD.Dodávka", "Dodávka")} />
                <GridColumn field="sposobDopravy" title={localizationService.toLanguageString("PotvrdeniePrijmuD.Doprava", "Doprava")} />
                <GridColumn field="pocetBalikov" title={localizationService.toLanguageString("PotvrdeniePrijmuD.Balíkov a lotov", "Balíkov a lotov")} />
                <GridColumn field="pocetKs" title={localizationService.toLanguageString("PotvrdeniePrijmuD.Počet ks", "Počet ks")} />
            </Grid>
        );
    }

    render() {
        let gridContent = this.state.loading ? <LoadingPanel /> : this.renderGrid();

        return (
            <div id="PotvrditPrijemDodavkyDialog">
                <div id="PotvrditPrijemDodavkyMessage" className="alert alert-warning">
                    <Localization
                        messageKey={
                            "PríjemDod_Potvr.Príjem potvrdíte naskenovaním čiarového kódu jedného balíka z dodávky.\r\nPri presunoch naskenujte jeden balík z akejkoľvek predajne."
                        }
                        defaultMessage={
                            "Príjem potvrdíte naskenovaním čiarového kódu jedného balíka z dodávky.\r\nPri presunoch naskenujte jeden balík z akejkoľvek predajne."
                        }
                        replaceNewLines={true}
                    />
                </div>
                <KeyboardEventHandler
                    handleKeys={CiarovyKodAllowedHandleKeys}
                    onKeyEvent={(key, e) => this.handleKeyEvent(key, e)}
                    handleFocusableElements={true}
                />
                <NasnimanyCiarovyKod keyboardEvent={this.state.keyboardEvent}>
                    <CheckBalikFromCiarovyKod getResponse={this.CheckNewBalik} />
                </NasnimanyCiarovyKod>
                {gridContent}
            </div>
        );
    }
}

export default PotvrditPrijemDodavkyDialogContent;

registerForLocalization(PotvrditPrijemDodavkyDialogContent);



// WEBPACK FOOTER //
// ./src/components/dialogs/PrijomDodavok/PotvrditPrijemDodavkyDialogContent.js